import '../models/account_settings/user_profile_attributes/user_profile_attribute.js.coffee'

Namespace 'Process.Methods'

class Process.Methods.ContentExporter extends Backbone.View

  baseExportableFieldsHash:
    'avatar': 'social_user_avatar',
    'description': 'social_user_description',
    'name': 'social_user_name',
    'source': 'social_user_source',
    'source_id': 'social_user_source_id'

  initialize: ({
    actionContainer, exportableFieldsContainer, uniqueUsers, totalContents, searchQuery
  }) ->
    @actionContainer = actionContainer
    @exportableFieldsContainer = exportableFieldsContainer
    @uniqueUsers = uniqueUsers
    @totalContents = totalContents
    @searchQuery = searchQuery


  exportProfiles: =>
    new AccountSettings.UserProfileAttributeCollection().fetch success: (attributes) =>
      @showModal(attributes)

  showModal: (attributes) ->
    userProfileAttributes = attributes.map((model) -> model.get('name')).concat(['tags'])
    @exportableFieldsHash = @baseExportableFieldsHash
    translatedFields = @_translateDefaultExportableFields(@exportableFieldsHash)
    @exportableFieldsView = new Monitoring.Dashboard.SocialUserExportableFieldsView(translatedFields, @uniqueUsers)
    @listenTo(@exportableFieldsView, 'on-export-confirm', @_exportantionConfirmed)
    @listenTo(@exportableFieldsView, 'on-json-export-confirm', @_jsonexportantionConfirmed)

    @exportableFieldsContainer.append(@exportableFieldsView.render().el)
    @userProfileAttributesHash = @_userProfileAttributesToHash(userProfileAttributes)

    @exportableFieldsView.addSection(
      translatedFields,
      I18n.t('monitoring.exportable_fields.social_user.default_exportable_fields'),
      true
    )
    @exportableFieldsView.addSection(
      @userProfileAttributesHash,
      I18n.t('monitoring.exportable_fields.social_user.profile_custom_attributes'),
      false
    )
    @exportableFieldsView.showModal()

  _export: (action, message, contentsCount) =>
    return if @actionContainer.hasClass('disabled')
    params = @searchQuery
    params['fields_to_export'] = @_selectedFields(@userProfileAttributesHash, @exportableFieldsHash)
    params['total_social_contents'] = @totalContents || 0
    params['total_user_profiles'] = @uniqueUsers || 0
    @_startExportation(action, message, params)

  _startExportation: (action, message, params) =>
    exportJob = new Monitoring.Methods.AsyncJob()
    exportJob.bind('completed', (results) => @_onComplete(results))
    exportJob.bind('failed', (results) => @_onFailure(message))
    exportJob.start action, params

  _onComplete: (results) =>
    if !results.hasOwnProperty('auto_download') || results.auto_download
      window.open(results.path, '_blank');

  _onFailure: (message) =>
    @actionContainer.button('reset').text('Export failed, retry?').addClass('warning')
    showError(message)


 ## Data formatting methods
  _selectedFields: (user_profile_attributes, exportable_fields_hash)=>
    h1 = {'custom': @exportableFieldsView._selectedFromHash(user_profile_attributes)}
    h2 = @exportableFieldsView._selectedFromHash(exportable_fields_hash)
    Object.assign({}, h2, h1)

  _translateDefaultExportableFields: (exportable_fields_hash)=>
    result = {}
    for key in Object.keys(exportable_fields_hash)
      result[key] = I18n.t('monitoring.exportable_fields.social_user.' + exportable_fields_hash[key])
    result

  _userProfileAttributesToHash: (custom_atributes)=>
    hash = {}
    for atr, index in custom_atributes
      hash[index.toString()] = custom_atributes[index]
    hash

  ## Events to caller dashboard
  _exportantionConfirmed: =>
    @_export('social_users_export_excel', I18n.t('export_error'), @uniqueUsers)

  _jsonexportantionConfirmed: =>
    @_export('social_users_export_json', I18n.t('export_error'), @uniqueUsers)
